export default __webpack_public_path__ + "static/media/e4.a978bda6.svg";